import { ANIMATION_DELAYS } from "../froala/constants";

const LINES = "p, h1, h2, h3, li";

/**
 * The per-line reveal delays Froala saves into the text (Froala.tsx
 * updateAnimations): every p, h1–h3 and li, in order, `--fr-anim-delay` of
 * index × the speed's step. Readers stagger lines from these, so ProseMirror
 * text stores them too and animates exactly like Froala text, with no viewer
 * change. Without an animation the delays are removed.
 */
export const withAnimationDelays = (
  html: string,
  animation: { speed?: string } | null | undefined,
): string => {
  if (!html || (!animation && !html.includes("--fr-anim-delay"))) return html;
  const doc = new DOMParser().parseFromString(html, "text/html");
  const step =
    ANIMATION_DELAYS[animation?.speed ?? "medium"] ?? ANIMATION_DELAYS.medium;
  doc.body.querySelectorAll<HTMLElement>(LINES).forEach((line, i) => {
    if (animation) {
      line.style.setProperty("--fr-anim-delay", `${step * i}ms`);
      return;
    }
    line.style.removeProperty("--fr-anim-delay");
    if (!line.getAttribute("style")?.trim()) line.removeAttribute("style");
  });
  return doc.body.innerHTML;
};
